/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../../../../client-dashboard/src/app/services/api.config';
import useDataFetchIndicator from '../useDataFetchIndicator';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.PartnerAccountFundAndTransferResponse,
  partnerAccountTransfer: (params: vp.PartnerAccountTransferRequest) => Promise<vp.PartnerAccountFundAndTransferResponse>,
  initiatePartnerAccountTransfer: (params: vp.PartnerAccountTransferRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostPartnerAccountFundAndTransfer: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldPartnerAccountFundAndTransfer, sethSouldPartnerAccountFundAndTransfer] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.PartnerAccountTransferRequest>({
    TransferTypeID: '',
    DebitorAccountID: '',
    RecipientAccountID: '',
    Amount: '',
    Currency: '',
    ClientReferenceNumber: '',
    Notes: '',
  });
  const [response, setResponse] = useState<vp.PartnerAccountFundAndTransferResponse>({
    Success: false,
    ErrorMessage: '',
    FundingTransactionID: '',
    AccountTransferID: '',
  });

  useEffect(() => {
    if (!shouldPartnerAccountFundAndTransfer) return () => {};

    const PostPartnerAccountFundAndTransfer = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postPartnerAccountFundAndTransfer(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldPartnerAccountFundAndTransfer) void PostPartnerAccountFundAndTransfer();
    sethSouldPartnerAccountFundAndTransfer(false);
    return () => {
      source.cancel();
    };
  }, [shouldPartnerAccountFundAndTransfer]);

  return [
    response,
    (_params: vp.PartnerAccountTransferRequest) => api.postPartnerAccountFundAndTransfer(_params, source),
    (_params: vp.PartnerAccountTransferRequest) => {
      setParams(_params);
      sethSouldPartnerAccountFundAndTransfer(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        FundingTransactionID: '',
        AccountTransferID: '',
      });
      sethSouldPartnerAccountFundAndTransfer(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostPartnerAccountFundAndTransfer);
